import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IDesignatedLeaguesPageResult {
  fetch: {
    Common: {
      DesignatedLeagues: {
        Content: string | null;
      } | null;
    };
  };
}

export type WithDesignatedLeaguesPageQueryProps = QueryResult<
  IDesignatedLeaguesPageResult
>;

class DesignatedLeaguesPageQuery extends Query<IDesignatedLeaguesPageResult> {}

const withDesignatedLeaguesPageQuery = <
  P extends WithDesignatedLeaguesPageQueryProps
>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithDesignatedLeaguesPageQueryProps>> => props => {
  return (
    <DesignatedLeaguesPageQuery
      query={queries.GET_DESIGNATED_LEAGUES_PAGE_DATA}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </DesignatedLeaguesPageQuery>
  );
};

export default withDesignatedLeaguesPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withDesignatedLeaguesPageData.tsx